module.exports = __webpack_public_path__ + "static/img/list-dreamWearNasalMask.0be5475.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/list-dreamWearNasalMask.png
// module id = iNrA
// module chunks = 1